import { cn } from '@/lib/utils';

function SkeletonList({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={cn('flex w-full flex-col items-start gap-2.5 p-2.5', className)} {...props}>
      {[...Array(3)].map((_, i) => (
        <div key={i} className="flex h-[77px] w-full flex-col items-start space-y-1.5 rounded-md bg-white p-2.5 shadow-md">
          <div className="flex h-[36px] w-full flex-row items-center space-x-2.5 p-0">
            <div className="bg-grey-2 h-9 w-9 rounded-[36px]"></div>
            <div className="bg-grey-2 h-4 w-[150px] rounded"></div>
          </div>
          <div className="bg-grey-2 h-4 w-[260px] rounded"></div>
        </div>
      ))}
    </div>
  );
}

export { SkeletonList };
